import ExpressionContext from './ExpressionContext';
import { compose, withProps } from 'recompose';
import gql from 'graphql-tag';
import { toWebhookExpressionScope } from './ExpressionTransform';

export const WebhookContext = gql`
  query WebhookContext($context: ID!) {
    webhook(id: $context) {
      id
      fields {
        nodes {
          id
          name
          value
        }
      }
    }
  }
`;

export default compose(
  withProps(() => ({
    query: WebhookContext,
    transform: toWebhookExpressionScope
  }))
)(ExpressionContext);
